
// const baseUrl = "http://localhost:8001/api/backend";
const baseUrl = `${process.env.REACT_APP_BASE_URL || ""}/api/backend`;

export default baseUrl;
